var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',[_c('v-text-field',{staticStyle:{"width":"180px"},attrs:{"value":_vm.value,"rules":_vm.validate,"clearable":"","label":"に一致する"},on:{"change":_vm.handleChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }